import React, { FC, ReactNode } from "react";
import Tooltip from "@mui/material/Tooltip";
import { useTheme } from "styled-components";

interface Props {
    title: ReactNode;
    children: ReactNode;
    placement?:
    | "top" | "bottom" | "left" | "right"
    | "top-start" | "top-end" | "bottom-start" | "bottom-end"
    | "left-start" | "left-end" | "right-start" | "right-end";
    offset?: number;
    disabled?: boolean;
    zIndex?: number;
}

export const NgTooltip: FC<Props> = ({
    title,
    children,
    placement = "bottom",
    offset = 8,
    disabled,
    zIndex,
}) => {
    const theme = useTheme() as any;

    const bg = theme?.palette?.black ?? "#000";
    const text = theme?.palette?.common?.white ?? "#fff";
    const fontSize = theme?.fontSize?.default ?? "0.85rem";
    const borderRadius = theme?.radius?.xSmall ?? 1.5;

    if (disabled) return <>{children}</>;

    return (
        <Tooltip
            title={title}
            placement={placement}
            slotProps={{
                popper: {
                    modifiers: [{ name: "offset", options: { offset: [0, offset] } }],
                    style: zIndex != null ? { zIndex } : undefined,
                },
                tooltip: {
                    sx: {
                        bgcolor: bg,
                        color: text,
                        fontSize: fontSize,
                        borderRadius: borderRadius,
                        p: "8px 12px",
                    },
                },
                arrow: { sx: { color: bg } },
            }}
            arrow
        >
            {children as any}
        </Tooltip>
    );
};
